import { MouseEventHandler } from "react";

import clsx from "clsx";
import styles from "./StartTrialButton.module.css";

type Props = {
  freeTrialActive: boolean;
  freeDays: number;
  onClick: MouseEventHandler;
};
const StartTrialButton = ({
  freeTrialActive,
  freeDays,
  onClick,
}: Props) => {
  return (
    <div className={clsx( styles.buttonWrapper)}>
      <button className={clsx("button", styles.button)} onClick={onClick}>
        {freeTrialActive ? `Start ${freeDays}-day Free Trial` : "Subscribe"}
      </button>
    </div>
  );
};
export default StartTrialButton;
